
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import { Component } from 'react';

class StatisticsPopup extends Component {
    componentDidMount () {
        console.log(this.props, 'PROPS');
    }
    render () {
        // eslint-disable-next-line no-undef
        return Template.default.apply(this);
    }
}
export default StatisticsPopup;